import api from './api';

export function getUser(username) {
  return api.get(`/api/v2/users/${username}`);
}

export function getUsers() {
  return api.get(`/api/v2/users`);
}
